import { AssetExpensePosition, PendingDocumentMove } from "../../../api/ClientFileApi";

export const ExpensesMaxLength = {
  costSharingExplanation: 4000,
  expenseRemarks: 4000,
} as const;

export const MINIMUM_LIVING_COSTS = 200;

export interface ExpenseRowConfig {
  position: AssetExpensePosition;
  isIndented?: boolean;
}

export const EXPENSE_ROWS: readonly ExpenseRowConfig[] = [
  { position: AssetExpensePosition.Rent },
  { position: AssetExpensePosition.HomeOwnership },
  { position: AssetExpensePosition.Energy },
  { position: AssetExpensePosition.Heating },
  { position: AssetExpensePosition.Phone },
  { position: AssetExpensePosition.Broadcasting },
  { position: AssetExpensePosition.Childcare },
  { position: AssetExpensePosition.PublicTransport },
  { position: AssetExpensePosition.HouseholdInsurance },
  { position: AssetExpensePosition.LifeInsurance },
  { position: AssetExpensePosition.OtherInsurance },
  { position: AssetExpensePosition.Vehicles },
  { position: AssetExpensePosition.VehicleInsuranceAndTax, isIndented: true },
  { position: AssetExpensePosition.Fuel, isIndented: true },
  { position: AssetExpensePosition.Parking, isIndented: true },
  { position: AssetExpensePosition.LivingCosts },
  { position: AssetExpensePosition.Other },
];

export interface ExpensePositionFormValue {
  amount: number | null;
  debtorShare: number | null;
}

export type ExpensePositionsFormValue = Record<AssetExpensePosition, ExpensePositionFormValue>;

export interface AssetExpensesFormValues {
  hasIllnessExtraCosts: boolean | null;
  illnessExtraCostAmount: number | null;
  paysCostsAlone: boolean | null;
  costSharingExplanation: string | null;
  expenseRemarks: string | null;
  positions: ExpensePositionsFormValue;
  expenseProofs: File[];
  documentMoves: PendingDocumentMove[];
}

const POSITIONS_WITH_INFO = [
  AssetExpensePosition.Rent,
  AssetExpensePosition.Phone,
  AssetExpensePosition.LivingCosts,
  AssetExpensePosition.Other,
] as const;

export type ExpensePositionWithInfo = (typeof POSITIONS_WITH_INFO)[number];

export function hasPositionInfo(position: AssetExpensePosition): position is ExpensePositionWithInfo {
  return (POSITIONS_WITH_INFO as readonly AssetExpensePosition[]).includes(position);
}
